import { render, staticRenderFns } from "./BackerCenterSection.vue?vue&type=template&id=5c572198"
import script from "./BackerCenterSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports